// src/firebase/config.js
const firebaseConfig = {
    apiKey: "AIzaSyBwKDZrXe-ZNRs4KvQByL_IV9hrI1idpTQ",
    authDomain: "cosknow.firebaseapp.com",
    projectId: "cosknow",
    storageBucket: "cosknow.firebasestorage.app",
    messagingSenderId: "1013161197935",
    appId: "1:1013161197935:web:8c23b54ad1f48ac285e89a"
  };
  
  export default firebaseConfig;